export default "__VITE_ASSET__fc59e380__"